import { atom } from 'jotai';
import { BluecoinData, BluecoinsData, FiltersBluecoin } from './types';
import { localForageEffect } from '../../../store/jotai/effects/localForageEffect';

export const bluecoinsAtom = atom<BluecoinsData>({});

export const selectedBluecoinsAtom = atom<number[]>([]);

export const isBluecoinPanelOpenAtom = atom<number | false>(false);

export const isBluecoinListPanelOpenAtom = atom<number[] | false>(false);

export const bluecoinsArrayAtom = atom<BluecoinData[]>((get) => {
  const bluecoinsData = get(bluecoinsAtom);
  return Object.keys(bluecoinsData).map((bluecoinId: string) => bluecoinsData[Number(bluecoinId)]);
});

export const filteredBluecoinStringAtom = atom<string>('');

export const filteredBluecoinsAtom = atom<BluecoinData[]>([]);

export const activeFilterBluecoinsAtom = atom<FiltersBluecoin | null>(null);

export const isBluecoinDataLoadingAtom = atom<boolean>(false);

export const selectedBluecoinStatusAtom = atom<string | null>(null);

export const isBluecoinsOpenAtom = atom<boolean>(false);

export const isBluecoinsOpenLocalForageEffectAtom = localForageEffect(
  isBluecoinsOpenAtom,
  'isBluecoinsMapOpen'
);

export const bluecoinIdAtom = atom<number | null>(null);

export const bluecoinsDataAtom = atom<BluecoinData[]>((get) => {
  const selected = get(selectedBluecoinsAtom);
  const selectedBluecoins = Array.isArray(selected) ? selected : [];
  const bluecoinsArray = get(bluecoinsArrayAtom);
  return bluecoinsArray.filter((bluecoin: BluecoinData) =>
    selectedBluecoins.includes(bluecoin.bluecoinId)
  );
});

export const closeBluecoinsAtom = atom(null, (_get, set) => {
  set(isBluecoinsOpenAtom, false);
  set(isBluecoinPanelOpenAtom, false);
  set(isBluecoinListPanelOpenAtom, false);
  set(isBluecoinDataLoadingAtom, false);
  set(bluecoinIdAtom, null);
  set(selectedBluecoinsAtom, []);
  set(bluecoinsAtom, {});
  set(filteredBluecoinStringAtom, '');
  set(filteredBluecoinsAtom, []);
  set(activeFilterBluecoinsAtom, null);
});
